import React, { Component } from 'react';

import ReadmoreArticles from "./components/Readmore-Articles/Readmore-Articles"
import ReadmoreVideo from "./components/Readmore-Video/Readmore-Video"

import "./Readmore.scss"
import data from "../../api/data.json"

class Readmore extends Component {
  render() {
    return (
      <section className="section section-readmore">
        <ReadmoreVideo data={data.footer.readmore.video} />
        <ReadmoreArticles articles={data.footer.readmore.articles} />
      </section>
    );
  }
}

export default Readmore;



// WEBPACK FOOTER //
// ./src/components/Readmore/Readmore.js